<template>
  <div v-if="$store.getters.getWorkOrderDataProps.length>0">
    
    <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; width: 100%;">

        <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: space-between; width: 100%;">
          <div>
            <span v-html="'&nbsp;'"></span>
          </div>
          
          <div style="text-align: right;">
            <el-dropdown 
                v-if="$store.getters.getWorkOrderDataProps[0].id>0 && (popup || $store.getters.getWorkOrderDataProps.length === 1)"
                @command="handleDropdownCommand">
                <el-button size="small" style="margin-right: 20px;">
                    Print/Hold <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown" align="left">
                  
                    <el-dropdown-item :command="{command: 'printWO', data: $store.getters.getWorkOrderDataProps[0]}" :disabled="!isWOConfirmed">Print Work-Order</el-dropdown-item>  
                    <el-dropdown-item :command="{command: 'printWOQR', data: $store.getters.getWorkOrderDataProps[0]}" :disabled="!isWOConfirmed">Print QR Tags</el-dropdown-item>  
                    <el-dropdown-item divided></el-dropdown-item>  
                    <el-dropdown-item :command="{command: 'viewProductionStatus', data: $store.getters.getWorkOrderDataProps[0]}" :disabled="!isWOConfirmed">View/Hold Production</el-dropdown-item>  
                    
                </el-dropdown-menu>
            </el-dropdown>

            <el-button v-if="!$store.getters.getPreferenceProps.work_order_planner_not_required" @click="show_calendar=true" size="small" type="warning">
              Calendar
            </el-button>
            
            <el-button 
              v-if="(($store.getters.getWorkOrderDataProps[0].id>0
                      && checkIfModuleAccessAvailable('/manageworkorders', 'can_edit')) 
                          || ($store.getters.getWorkOrderDataProps[0].id === 0 
                              && checkIfModuleAccessAvailable('/manageworkorders', 'can_add'))) 
                                && !shortcut"
                style="margin-right: 5px;" 
                @click="submitWorkOrder(1)" 
                type="primary" 
                size="small">
                <span v-if="(getSaleItemList !== undefined && getSaleItemList.id>0) || $store.getters.getWorkOrderDataProps[0].id>0">
                  Submit To Production
                </span>
                <span v-else>
                  Save As Draft
                </span>
                </el-button>
            <el-popconfirm
              @confirm="goBack"
              title="Are you sure to go back?"
              >
                <el-button v-if="popup" slot="reference" size="small">Go Back</el-button>
            </el-popconfirm>
          </div>
          
                
        </div>
        <br>
        <div style="width: 100%; height: 100vh;">
          <Wrapper 
            :wo_index="0"
            @printTrial="printTrial"
            :wo_confirmed="wo_confirmed"
            :sale_item_index="sale_item_index"
            v-if="$store.getters.getWorkOrderDataProps.length === 1"
            :workOrderData="$store.getters.getWorkOrderDataProps[0]"/>
            
          <el-tabs 
              type="border-card"
              v-else
              v-model="activeTab">
              <el-tab-pane 
                v-for="(data, index) in $store.getters.getWorkOrderDataProps"
                :key="index"
                :name="'tab-'+index+''"
                :label="data.tailoring_item_name">

                  <div style="text-align: right;" v-if="!popup && data.id>0">            
                    <el-dropdown 
                        @command="handleDropdownCommand">
                        <el-button size="small" style="margin-right: 20px;">
                            Print/Hold <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown" align="left">
                          
                            <el-dropdown-item :command="{command: 'printWO', data}" :disabled="!isWOConfirmed">Print Work-Order</el-dropdown-item>  
                            <el-dropdown-item :command="{command: 'printWOQR', data}" :disabled="!isWOConfirmed">Print QR Tags</el-dropdown-item>  
                            <el-dropdown-item divided></el-dropdown-item>  
                            <el-dropdown-item :command="{command: 'viewProductionStatus', data}" :disabled="!isWOConfirmed">View/Hold Production</el-dropdown-item>  
                            
                        </el-dropdown-menu>
                    </el-dropdown>
                    
                  </div>
                  <Wrapper 
                      @printTrial="printTrial"
                      :wo_index="index"
                      :shortcut="shortcut"
                      :sale_item_index="sale_item_index"
                      :wo_confirmed="wo_confirmed"
                      :workOrderData="data"/>
              </el-tab-pane>
          </el-tabs>
        </div>
         
    </div>
    <PrintWindow 
      :title="getPrintTitle"
      v-if="isPrintWindowVisible"
      :src="getPrintSrc"
      :dialogVisible="isPrintWindowVisible" 
      @closePrintWindow="showPrintWindow = false" />

    <el-dialog
        v-if="showProductionList"
        :width="'95%'"
        :visible.sync="showProductionList"
        append-to-body>
            <ProductionList
                :sale_item_id="getSaleItemId"
                @closed="showProductionList = false"/>
    </el-dialog>

    <el-dialog
        v-if="show_calendar"
        :title="'Calendar'"
        width="80%"
        :visible.sync="show_calendar"
        append-to-body>
            <TaskCalendar :production_view="true" />
    </el-dialog>

  </div>
  <div v-else>
    <el-container style="height: 100vh;" v-loading.fullscreen.lock="true">>
      <span v-html="'&nbsp;'"></span>
    </el-container>
  </div>
</template>

<script>
import Wrapper from './Wrapper'
import ProductionList from './ProductionList'

export default {
  props: ['popup', 'sale_item_index', 'wo_confirmed', 'shortcut'],
  components: {Wrapper, ProductionList},
  data() {
    return {
      search_text: '',
      activeTab: 'tab-0',
      printTitle: '',
      printSrc: '',
      showPrintWindow: false,
      showProductionList: false,
      sale_item_id: 0,
      show_calendar: false
    }
  },
  computed: {
      getSaleItemId() {
        return this.sale_item_id
      },
      getPopup() {
        return this.popup
      },
      isWOConfirmed() {
        return true//this.$store.getters.getSaleMasterDataProps.sale_status >0 || 
      },
      getPrintTitle() {
          return this.printTitle
      },
      getPrintSrc() {
          return this.printSrc
      },
      isPrintWindowVisible() {
          return this.showPrintWindow
      },
      getSaleItemList() {

        return this.$store.state.saleMaster.props.item_list[this.sale_item_index]
        if(this.sale_item_index !== undefined && this.sale_item_index>=0) {
          let list = this.$store.state.saleMaster.props.item_list.filter(t => t.sl_no === this.sale_item_index)
          return list
        }
        return []

      }
  },
  methods: {
    printTrial($event) {
        this.printTitle = 'Paper Size: A4'
        this.printSrc = this.master_url+'target=trialWorkOrder&subpage=print&trial_id='+$event.trial_id+'&access_token='+this.$store.getters.getAccessToken
        this.showPrintWindow = true
    },
    goBack() {
      this.$emit('closed')
    },
    handleDropdownCommand(command) {

      if(command == "submitFinal") {

          this.submitWorkOrder(1)

      } else if(command.command == "printWO") {

          this.printTitle = this.$store.getters.getPreferenceProps.print_thermal_wo ? 'Paper Size: Thermal' : 'Paper Size: '+(this.$store.getters.getPreferenceProps.print_a5_wo ? 'A5' : 'A4')
          this.printSrc = this.master_url+'target=workOrder&subpage=print&type=multi&work_order_id='+command.data.id+'&sale_item_id='+command.data.sale_item_id+'&access_token='+this.$store.getters.getAccessToken
          this.showPrintWindow = true

      } else if(command.command == "printWOQR") {
          
          this.printTitle = 'Paper Size: Custom'
          this.printSrc = this.master_url+'target=printQrTag&subpage=print&print_type=workorder&id=0&work_order_id=0&sale_item_id='+command.data.sale_item_id+'&access_token='+this.$store.getters.getAccessToken
          this.showPrintWindow = true

      } else if(command.command == "viewProductionStatus") {
        this.sale_item_id = command.data.sale_item_id
        this.showProductionList = true
      }
      
    },
    async submitWorkOrder(status) {
        
      let proceed = true
      this.$store.getters.getWorkOrderDataProps.forEach(element => {
          element.work_order_status = status
      })

      if(proceed) {
        if(this.sale_item_index>=0) {

          let itemListSingle = this.$store.state.saleMaster.props.item_list[this.sale_item_index]
          
          itemListSingle.work_order = this.$store.getters.getWorkOrderDataProps
          itemListSingle.extra_charge_unit_rate = 0
          itemListSingle.extra_charge_description = '<ul style="padding: 0px;">'

          itemListSingle.work_order.forEach(element => {
                
                element.style_list.forEach(style => {
                  console.log(JSON.stringify(style))
                  if(style.extra_charge>0) {
                    itemListSingle.extra_charge_unit_rate = parseFloat(itemListSingle.extra_charge_unit_rate) + (parseFloat(style.extra_charge)*parseFloat(style.qty))
                    itemListSingle.extra_charge_description 
                      = itemListSingle.extra_charge_description + "<li>" +style.extra_charge_notes+' @ '+(this.formatCurrency(parseFloat(style.extra_charge)*parseFloat(style.qty)))+ "</li>"
                  } else if(style.option_detail.option_name && style.option_detail.option_name.length > 0) {
                    itemListSingle.extra_charge_description 
                      = itemListSingle.extra_charge_description + "<li>" +style.style_name+': '+style.option_detail.option_name+ "</li>"
                  }
                })

                element.process_list.forEach(process => {
                  if(process.is_required && process.extra_charge>0) {

                    let processCharge = parseFloat(process.extra_charge)
                    let extraChargeDescription = process.process_name

                    process.option_list.forEach(processOption => {
                      if(processOption.id === process.process_option_id) {
                        processCharge = processCharge + parseFloat(processOption.extra_charge)
                      }                      
                    })

                    itemListSingle.extra_charge_unit_rate = parseFloat(itemListSingle.extra_charge_unit_rate) + processCharge
                    itemListSingle.extra_charge_description = itemListSingle.extra_charge_description + "<li>" +extraChargeDescription+ "</li>"

                  }
                })

          })

          itemListSingle.extra_charge_description += "</ul>"

          if((this.sale_item_index>=0 && this.getSaleItemList.id > 0)) {

            let woPayload = JSON.parse(JSON.stringify(this.$store.getters.getWorkOrderDataProps))
            woPayload.forEach(element => {
              
              element.sale_item_id = this.getSaleItemList.id

              if(this.getSaleItemList.combination_item_list.length > 0) {
                let combinationList = this.getSaleItemList.combination_item_list.filter(t => t.tailoring_item_id === element.tailoring_item_id)
                element.sale_sub_item_id = combinationList[0].id

              }
              
            })

            let sale_item_index = this.sale_item_index !== undefined && this.sale_item_index>=0 ? this.sale_item_index : -1
            await this.$store.dispatch('submitWorkOrderData', {shortcut: this.shortcut ? true : false, work_order_list: woPayload, sale_item_index: sale_item_index, sale_id: this.$store.state.saleMaster.props.id})

            setTimeout(() => {
              console.log(this.sale_item_index)
              if(this.$store.state.saleMaster.props.item_list[this.sale_item_index].work_order_id === 0) {
                this.$store.state.saleMaster.props.item_list[this.sale_item_index].work_order = []
                this.$store.state.saleMaster.props.item_list[this.sale_item_index].work_order_id = 1              
              }
              this.$emit('closed')
            }, 1000);
          } else {
            this.$emit('closed')
          }
          
        } else {
          this.$store.dispatch('submitWorkOrderData', {shortcut: this.shortcut ? true : false, work_order_list: this.$store.getters.getWorkOrderDataProps})
        }
        
      }
      
    }
  },
  mounted() {
    if(this.$store.getters.getEmployeeMasterList.length === 0) {
        this.$store.dispatch('fetchEmployeeMasterList', {store_list: this.$store.getters.getAccessibleStoreList})
    }
    if(this.$store.getters.getTailoringTrialTypeList.length === 0) {
        this.$store.dispatch('fetchTailoringTrialTypeList')
    }
    setTimeout(() => {
        //this.$store.dispatch('lazyLoadWorkOrderSections', this.$store.getters.getWorkOrderDataProps)
    }, 1000);
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/WorkOrder/Index.vue